$(function () {
    let currentSize = null;

    const redraw = function () {
        const bp = $('<div style="position: absolute; left: -10000px;"><div class="d-none d-xxl-block" data-bp="xxl"></div><div class="d-none d-xl-block" data-bp="xl"></div><div class="d-none d-lg-block" data-bp="lg"></div><div class="d-none d-md-block" data-bp="md"></div><div class="d-none d-sm-block" data-bp="sm"></div></div>');
        const size = bp.appendTo('body').children(':visible').first().data('bp') || 'xs';
        bp.remove();
        if (currentSize === size && size !== 'xs') { return; }
        currentSize = size;

        // remove the height of all the tables
        $('.scroll-table').find('th, td').css('height', null);
        $('.scroll-table').each(function () {
            // get the height of all the rows
            const heights = [];
            const $this = $(this);
            $this.find('.scroll-table--content tr').each(function (index) {
                heights.push($(this).outerHeight());
            });
            $this.find('.table').each(function () {
                $(this).find('tr').each(function (index) {
                    $(this).find('th, td').css('height', heights[index] + 'px');
                });
            });
            checkEdges($this.find('.scroll-table--content'));
        });
    }

    const checkEdges = function (ev) {
        const $this = $(ev.target || ev);
        const maxWidth = $this.children(':first-child').width();
        const left = $this.scrollLeft();
        if (left > 0) {
            $this.parent().removeClass('at-left-edge');
        } else {
            $this.parent().addClass('at-left-edge');
        }
        if (left + $this.width() < maxWidth) {
            $this.parent().removeClass('at-right-edge');
        } else {
            $this.parent().addClass('at-right-edge');
        }
    }

    // setup the tables
    $('.scroll-table').each(function () {
        const $this = $(this);
        const $tblWrapper = $this.find('.scroll-table--table');
        const $tbl = $($tblWrapper.find('table').parent().html());
        $tbl.find('td:not(:first-child), th:not(:first-child)').remove();
        $tblWrapper.find('table').wrap('<div class="scroll-table--content" />');
        $tblWrapper.prepend($('<div class="scroll-table--label" />').append($tbl));

        $this.find('.scroll-table--header--prev, .scroll-table--header--next').on('click', function (ev) {
            ev.preventDefault();
            const sign = $(this).is('.scroll-table--header--prev') && -1 || 1;
            $this.find('.scroll-table--content').scrollLeft($this.find('.scroll-table--content').scrollLeft() + (200 * sign));
        });
    }).find('.scroll-table--content').on('scroll', checkEdges);

    $(window).on('resize', redraw);
    redraw();
});